import styled from 'styled-components';

export const SelectedViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  /* height: 100%; */
`;

interface IInnerDataContainer {
  mustOverflow?: boolean;
}
export const InnerDataContainer = styled.div<IInnerDataContainer>`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${props => props.mustOverflow && 'overflow-y: scroll;'}

  h4 {
    font-size: 18px;
    font-weight: bold;
    opacity: 0.9;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;

    img {
      width: 18px;
    }
  }

  /* div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  } */

  strong {
    margin-right: 2px;
    font-weight: bold;
    opacity: 1;
    font-size: 15px;
  }

  > small {
        background: ${({ theme }) => theme.colors.blue[50]};
        color: ${({ theme }) => theme.colors.blue[900]};
        font-weight: bold;
        text-transform: uppercase;
        padding: 4px;
        border-radius: 4px;
        font-size: 11px;
        width: 100%;
        text-align: center;
        margin-top: 8px;
      }

      small.green {
          background: ${({ theme }) => theme.colors.green[100]};
          color: ${({ theme }) => theme.colors.green[500]};
      }

      small.orange {
          background: ${({ theme }) => theme.colors.orange[100]};
          color: ${({ theme }) => theme.colors.orange[500]};
        }

      small.gray {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[900]};
      }

      small.red {
        background: ${({ theme }) => theme.colors.danger.light};
        color: ${({ theme }) => theme.colors.danger.dark};
      }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 4px 0px;
  margin-right: 16px;

  div.title {
    margin: 4px 0px;
    font-size: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      font-size: 16px;
    }
    img {
      &:hover {
        opacity: 0.6
      }
      cursor: help;
      filter: ${({ theme }) => theme.filters.primary};
      width: 21px;
      transition: all 0.2s ease-in-out;
    }
  }

  span {
    max-height: 66px;
    overflow: auto;
    margin-bottom: 2px;
  }

  & + & {
    margin-top: 8px;
  }
`;
export const RangeSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  bottom: 10px;
  gap: 4px;

  .range-slider {
      width: 100%;
      .range-slider__range {
        background: ${({ theme }) => theme.colors.primary.main};
      }
      .range-slider__thumb {
        background: ${({ theme }) => theme.colors.primary.main};
      }
      .single-thumb {
        width: 0;
      }
      .range-slider__thumb[data-lower] {
        width: 0;
      }
      .range-slider__range {
        border-radius: 6px;
      }
    }

  @media(max-width: 500px) {
      width: 50%;
      margin-top: 8px;
    }
  header {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 700;
  }
`;
